import { Requirement } from "./requirement";
import { Species } from "./species";
import { User } from "./user";
import { Site } from "./site";
import { Tag } from "./tag";

export type RequirementAsk = {
  perform: string;
  coachObserve: string;
  rate: number;
};

export type RequirementDiscuss = {
  suggestion: string;
  improvement: string;
};

export type RequestFeedbackType = {
  observationDate: string;
  site: string;
  course: string;
  selectedCoach: User | null;
  mrn: string;
  selectedSpecies: Species | null;
  animalSex: string;
  SelectedCompetencySkills: Requirement[];
  ask: RequirementAsk[];
  discuss: RequirementDiscuss[];
  notes: string;
  timerData: { startTimeStamp: string; durationInSeconds: number } | null;
};

export type FeedbackSkillType = {
  actions: string;
  areas: string;
  coach_comments: string;
  feedback_skill_id: string;
  note?: string;
  requirement: Requirement;
  self_rating?: number | null;
  coach_rating?: number | null;
  student_comments: string;
  skill_level?: number;
};

export type FeedbackType = {
  feedback_id: string;
  animal_sex?: string;
  animal_size?: string;
  coach: User;
  coach_id: string;
  created_at?: string;
  reviewed_at?: string;
  feedback_skills: FeedbackSkillType[];
  mrn: string;
  note_to_coach: string;
  observation_date: string;
  org_id: string;
  organization?: {
    org_id: string;
    name: string;
    type?: string;
  };
  species: Species;
  species_id: string;
  status: string;
  student: User;
  student_id: string;
  site?: Site;
  course?: string;
  animal_name?: string;
  feedback_type?: string;
  tags?: { tag: Tag }[];
  coach_rate?: number;
  record_correction?: string | null;
  record_corrected_at?: string | null;
};

export enum FeedbackStatus {
  DONE = "DONE",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  DRAFT = "DRAFT",
  MISSING_INFO = "MISSING_INFO",
  EXPIRED = "EXPIRED",
  ARCHIVED = "ARCHIVED",
  HIDDEN = "HIDDEN",
}

export type ProcessedFeedback = {
  coachId: string;
  coach: User;
  avgResponseTime: number;
  feedbacks: FeedbackType[];
  category: string;
};
